import useDaiOptOut from './useDaiOptOut'

import constants from 'constants/index'

const useDaiPermissions = () => {
  const { daiOptOuts, isLoadingStart, refresh } = useDaiOptOut()
  const { STATUSES } = constants.dai.solutions

  const isEnabled = (item) => item?.status !== STATUSES.DISABLED

  const groups = daiOptOuts?.groups ?? []
  const solutions = daiOptOuts?.solutions ?? []
  const nestedSolutions = groups.flatMap((group) => group.solutions ?? [])

  const allItems = [...groups, ...solutions, ...nestedSolutions]

  const findByTag = (tag) => allItems.find((item) => item.tag === tag) ?? null

  const isTagEnabled = (tag) => {
    const item = findByTag(tag)
    return !item || isEnabled(item)
  }

  // Para soluções dentro de um grupo, passe a tag do grupo e a(s) tag(s) da solução.
  // Garante estabilidade caso o manageable do grupo mude entre unified e per_solution.
  const permitted = (tags) =>
    isEnabled(daiOptOuts?.global) && [tags].flat().some(isTagEnabled)

  return { permitted, isLoadingStart, refresh }
}

export default useDaiPermissions
